import rdcStrings from 'features/rdc/rdcStrings.en';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from 'shared/components/vxl/Dialog/Dialog';
import {
  PressableAnalyticsProps,
  usePressableAnalytics,
} from 'shared/hooks/analytics/usePressableAnalytics';

interface CaptiveDialogProps {
  isDialogVisible: boolean;
  setModalVisible: (isVisible: boolean) => void;
  primaryActionAnalytics?: PressableAnalyticsProps;
  secondaryActionAnalytics?: PressableAnalyticsProps;
  handlePrimaryAction: () => void;
  handleSecondaryAction: (value: boolean) => void;
}

const CaptiveDialog = ({
  isDialogVisible,
  setModalVisible,
  primaryActionAnalytics,
  secondaryActionAnalytics,
  handlePrimaryAction,
  handleSecondaryAction,
}: CaptiveDialogProps) => {
  const { captiveDialog } = rdcStrings;
  const { t: translatedText } = useTranslation('rdc', {
    keyPrefix: 'captiveDialog',
  });
  const logPrimaryButtonPressEvent = usePressableAnalytics({
    analyticsId: primaryActionAnalytics?.analyticsId,
    customAttributes: primaryActionAnalytics?.customAttributes,
  });

  const logSecondaryButtonPressEvent = usePressableAnalytics({
    analyticsId: secondaryActionAnalytics?.analyticsId,
    customAttributes: secondaryActionAnalytics?.customAttributes,
  });

  return (
    <Dialog
      isIOSCaptiveDialog
      isDialogVisible={isDialogVisible}
      setModalVisible={setModalVisible}
      titleText={translatedText('title', captiveDialog.title)}
      messageText={translatedText('message', captiveDialog.message)}
      dialogButtonProps={[
        {
          label: translatedText(
            'buttons.neverMind',
            captiveDialog.buttons.neverMind,
          ),
          onClick: () => {
            if (secondaryActionAnalytics) {
              logSecondaryButtonPressEvent();
            }
            handleSecondaryAction(false);
          },
        },
        {
          label: translatedText('buttons.cancel', captiveDialog.buttons.cancel),
          onClick: () => {
            if (primaryActionAnalytics) {
              logPrimaryButtonPressEvent();
            }
            handlePrimaryAction();
          },
        },
      ]}
    />
  );
};

export default CaptiveDialog;
